/**
 * bathbomb-product.js
 * バスボム商品ページ専用スクリプト
 *
 * 依存関係: window.bathbombPage / window.BATHBOMB_STOCK / window.BATHBOMB_VARIANTS
 *
 * UI フロー:
 *   STEP1: 購入タイプ選択（定期購入 / 単品購入）
 *   STEP2-A: 定期購入プラン固定表示（定期購入選択時）
 *   STEP2-B: 単品数量カウンター（単品購入選択時）
 *   STEP3: 香り選択（ゆず / ラベンダー / シダーウッド）
 *   STEP4: 金額確認・カートに追加
 *
 * 割引ロジック（単品購入のみ）:
 *   discountCount = Math.floor(qty / 3)
 *   discountAmount = discountCount × 1300
 *   合計 = UNIT_PRICE × qty - discountAmount
 *
 * カートAPI仮実装:
 *   /cart/add.js を使用（単品・定期共通）
 *   TODO: Mikawaya Subscription 連携時に定期購入部分を差し替える
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     定数
  ------------------------------------------------------------------ */
  var UNIT_PRICE      = Math.min.apply(null, Object.values(window.BATHBOMB_PRICES || { default: 2500 }));
  var SUB_PRICE       = 6500;
  var SUB_QTY         = 4;
  var DISCOUNT_UNIT   = 1300;
  var MIKAWAYA_PLAN_ID = 3948576984;
  var DISCOUNT_CYCLE = 3;

  var SUB_VARIANT_MAP = {
    yuzu: 51533644726488,
    lavender: 51533644759256,
    cedar: 51533644792024
  };

  /* ------------------------------------------------------------------
     香り設定
     variantKey: window.BATHBOMB_STOCK / BATHBOMB_VARIANTS のキーと一致
  ------------------------------------------------------------------ */
  var SCENT_KEYS = ['yuzu', 'lavender', 'cedar'];

  var SCENT_CONFIG = {
    yuzu:     { label: 'ゆず',         variantKey: 'ゆず' },
    lavender: { label: 'ラベンダー',   variantKey: 'ラベンダー' },
    cedar:    { label: 'シダーウッド', variantKey: 'シダーウッド' },
  };

  /* ------------------------------------------------------------------
     状態管理
  ------------------------------------------------------------------ */
  var state = {
    purchaseType: 'subscription',
    qty: 1,
    scentCounts: { yuzu: 0, lavender: 0, cedar: 0 },
  };

  /* ------------------------------------------------------------------
     ヘルパー
  ------------------------------------------------------------------ */
  function getLimit() {
    return state.purchaseType === 'subscription' ? SUB_QTY : state.qty;
  }

  function getTotalScents() {
    return SCENT_KEYS.reduce(function (sum, key) {
      return sum + (state.scentCounts[key] || 0);
    }, 0);
  }

  function getDiscountCount(qty) {
    return Math.floor(qty / DISCOUNT_CYCLE);
  }

  function formatYen(amount) {
    return '<span class="price-currency">¥</span>' + amount.toLocaleString('ja-JP');
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function isInStock(key) {
    var config = SCENT_CONFIG[key];
    if (!window.BATHBOMB_STOCK || !config) return true;
    var stock = window.BATHBOMB_STOCK[config.variantKey];
    return typeof stock !== 'number' || stock > 0;
  }

  function resetScentCounts() {
    state.scentCounts = { yuzu: 0, lavender: 0, cedar: 0 };
  }

  /** qty変更で上限が下がった場合、超過分を末尾の香りから削る */
  function trimScentCounts() {
    var limit = getLimit();
    var excess = getTotalScents() - limit;
    if (excess <= 0) return;
    for (var i = SCENT_KEYS.length - 1; i >= 0 && excess > 0; i--) {
      var key = SCENT_KEYS[i];
      var cut = Math.min(state.scentCounts[key] || 0, excess);
      state.scentCounts[key] = (state.scentCounts[key] || 0) - cut;
      excess -= cut;
    }
  }

  function showStep(el) {
    if (el) el.style.display = '';
  }

  function hideStep(el) {
    if (el) el.style.display = 'none';
  }

  /* ------------------------------------------------------------------
     STEP 1: 購入タイプ選択
  ------------------------------------------------------------------ */
  function initPurchaseType() {
    var group = document.getElementById('bathbombPurchaseTypeGroup');
    if (!group) return;

    group.addEventListener('click', function (e) {
      var card = e.target.closest('.bathbomb-radio-card');
      if (!card) return;

      var val = card.dataset.value;
      if (state.purchaseType === val) return;

      state.purchaseType = val;
      resetScentCounts();

      group.querySelectorAll('.bathbomb-radio-card').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.value === val);
        c.querySelector('input').checked = (c.dataset.value === val);
      });

      if (val === 'subscription') {
        showStep(document.getElementById('bathbombStep2Sub'));
        hideStep(document.getElementById('bathbombStep2One'));
      } else {
        hideStep(document.getElementById('bathbombStep2Sub'));
        showStep(document.getElementById('bathbombStep2One'));
      }

      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 単品数量カウンター
  ------------------------------------------------------------------ */
  function initQuantity() {
    var minusBtn = document.getElementById('bathbombQtyMinus');
    var plusBtn  = document.getElementById('bathbombQtyPlus');
    var input    = document.getElementById('bathbombQtyInput');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', function () {
      if (state.qty <= 1) return;
      state.qty--;
      input.value = state.qty;
      minusBtn.disabled = state.qty <= 1;
      trimScentCounts();
      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });

    plusBtn.addEventListener('click', function () {
      state.qty++;
      input.value = state.qty;
      minusBtn.disabled = false;
      renderScentGrid();
      renderQtyPromo();
      renderQtyDiscountBanner();
      renderPrice();
      renderCartState();
    });
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 訴求プロモカード
  ------------------------------------------------------------------ */
  function renderQtyPromo() {
    var el = document.getElementById('bathbombQtyPromo');
    if (!el) return;

    if (state.purchaseType !== 'one_time') {
      el.style.display = 'none';
      return;
    }

    var qty       = state.qty;
    var cycle     = Math.ceil(qty / DISCOUNT_CYCLE);
    var pos       = ((qty - 1) % DISCOUNT_CYCLE) + 1;
    var remaining = DISCOUNT_CYCLE - pos;

    var html;
    var modifier;

    if (pos === 1) {
      html     = DISCOUNT_CYCLE + '個購入ごとに '
               + '<span class="bathbomb-qty-promo-amount">' + formatYen(DISCOUNT_UNIT) + '割引</span>'
               + '！あと' + remaining + '個';
      modifier = '';
    } else if (pos === 2) {
      html     = '割引まで あと' + remaining + '個！まとめ買いでお得に';
      modifier = '';
    } else {
      // pos === 3
      html     = '<span class="bathbomb-qty-promo-amount">'
               + formatYen(DISCOUNT_UNIT * cycle) + '割引</span> 適用済み';
      modifier = 'bathbomb-qty-promo--done';
    }

    el.innerHTML = html;
    el.className = 'bathbomb-qty-promo' + (modifier ? ' ' + modifier : '');
    el.style.display = '';
  }

  /* ------------------------------------------------------------------
     STEP 2-B: 割引バナー
  ------------------------------------------------------------------ */
  function renderQtyDiscountBanner() {
    var banner = document.getElementById('bathbombQtyDiscountBanner');
    var label  = document.getElementById('bathbombQtyDiscountLabel');
    var sub    = document.getElementById('bathbombQtyDiscountSub');
    if (!banner) return;

    if (state.purchaseType !== 'one_time') {
      banner.style.display = 'none';
      return;
    }

    var discountCount = getDiscountCount(state.qty);
    if (discountCount <= 0) {
      banner.style.display = 'none';
      return;
    }

    banner.style.display = '';
    if (label) label.textContent = discountCount + '回分の割引が適用されます！';
    if (sub)   sub.innerHTML   =
      formatYen(discountCount * DISCOUNT_UNIT) + ' 引き（'
      + DISCOUNT_CYCLE + '個ごとに' + formatYen(DISCOUNT_UNIT) + '割引）';
  }

  /* ------------------------------------------------------------------
     STEP 3: 香りカウンター
  ------------------------------------------------------------------ */
  function initScentGrid() {
    var grid = document.getElementById('bathbombScentGrid');
    if (!grid) return;

    grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.bathbomb-scent-minus, .bathbomb-scent-plus');
      if (!btn || btn.disabled) return;

      var key   = btn.dataset.scentKey;
      var delta = btn.classList.contains('bathbomb-scent-plus') ? 1 : -1;
      var count = state.scentCounts[key] || 0;

      if (delta === 1) {
        if (getTotalScents() >= getLimit()) return;
        if (!isInStock(key)) return;
        state.scentCounts[key] = count + 1;
      } else {
        if (count <= 0) return;
        state.scentCounts[key] = count - 1;
      }

      renderScentGrid();
      renderPrice();
      renderCartState();
    });
  }

  function renderScentGrid() {
    var limit       = getLimit();
    var total       = getTotalScents();
    var limitReached = total >= limit;

    // カウンター表示
    var selEl = document.getElementById('bathbombScentSelected');
    var totEl = document.getElementById('bathbombScentTotal');
    if (selEl) selEl.textContent = total;
    if (totEl) totEl.textContent = limit;

    // 各香りカード更新
    SCENT_KEYS.forEach(function (key) {
      var count    = state.scentCounts[key] || 0;
      var inStock  = isInStock(key);
      var card     = document.querySelector('.bathbomb-scent-card[data-scent="' + key + '"]');
      var countEl  = document.getElementById('bathbombCount' + capitalize(key));
      if (!card) return;

      var minusBtn   = card.querySelector('.bathbomb-scent-minus');
      var plusBtn    = card.querySelector('.bathbomb-scent-plus');
      var stockBadge = card.querySelector('.bathbomb-scent-stock');

      if (countEl) countEl.textContent = count;

      if (!inStock) {
        card.classList.add('is-soldout');
        card.classList.remove('is-selected', 'is-disabled');
        if (stockBadge) stockBadge.style.display = '';
        if (minusBtn)   minusBtn.disabled = true;
        if (plusBtn)    plusBtn.disabled  = true;
      } else {
        card.classList.remove('is-soldout');
        if (stockBadge) stockBadge.style.display = 'none';
        card.classList.toggle('is-selected', count > 0);
        card.classList.toggle('is-disabled', limitReached && count === 0);
        if (minusBtn) minusBtn.disabled = count <= 0;
        if (plusBtn)  plusBtn.disabled  = limitReached;
      }
    });

    // 残り選択数メッセージ
    var remainingEl = document.getElementById('bathbombScentRemaining');
    if (remainingEl) {
      var remaining = limit - total;
      if (remaining > 0) {
        remainingEl.textContent = 'あと' + remaining + '個選択できます';
        remainingEl.style.display = '';
      } else {
        remainingEl.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 4: 金額表示
  ------------------------------------------------------------------ */
  function renderPrice() {
    var elTotal       = document.getElementById('bathbombPriceTotal');
    var elOrigRow     = document.getElementById('bathbombPriceOriginalRow');
    var elOrig        = document.getElementById('bathbombPriceOriginal');
    var elDiscRow     = document.getElementById('bathbombPriceDiscountRow');
    var elDiscLabel   = document.getElementById('bathbombDiscountCountText');
    var elDisc        = document.getElementById('bathbombPriceDiscount');
    var elUnitWrap    = document.getElementById('bathbombUnitPrice');
    var elUnitVal     = document.getElementById('bathbombUnitPriceVal');
    if (!elTotal) return;

    if (state.purchaseType === 'subscription') {
      elTotal.innerHTML = formatYen(SUB_PRICE);
      if (elOrigRow)  elOrigRow.style.display  = 'none';
      if (elDiscRow)  elDiscRow.style.display  = 'none';
      if (elUnitWrap) elUnitWrap.style.display = 'none';
      var inlineHide = document.getElementById('bathbombUnitPriceInline');
      if (inlineHide) inlineHide.style.display = 'none';
      return;
    }

    var qty           = state.qty;
    var discountCount = getDiscountCount(qty);
    var discountAmt   = discountCount * DISCOUNT_UNIT;
    var original      = UNIT_PRICE * qty;
    var total         = original - discountAmt;

    elTotal.innerHTML = formatYen(total);

    if (discountCount > 0) {
      if (elOrigRow)   elOrigRow.style.display  = '';
      if (elOrig)      elOrig.innerHTML           = formatYen(original);
      if (elDiscRow)   elDiscRow.style.display   = '';
      if (elDiscLabel) elDiscLabel.textContent   = discountCount + '回分割引';
      if (elDisc)      elDisc.innerHTML           = '−' + formatYen(discountAmt);
    } else {
      if (elOrigRow) elOrigRow.style.display = 'none';
      if (elDiscRow) elDiscRow.style.display = 'none';
    }

    if (elUnitWrap) elUnitWrap.style.display = '';
    if (elUnitVal)  elUnitVal.innerHTML       = formatYen(Math.floor(total / qty));

    /* インライン単価（数量カウンター横） */
    var inlineWrap    = document.getElementById('bathbombUnitPriceInline');
    var inlineBase    = document.getElementById('bathbombUnitPriceBase');
    var inlineActual  = document.getElementById('bathbombUnitPriceActual');
    var inlineActVal  = document.getElementById('bathbombUnitPriceActualValue');

    if (inlineWrap) {
      inlineWrap.style.display = '';
      if (inlineBase) inlineBase.innerHTML = '<span class="product-unit-price-value en">' + formatYen(UNIT_PRICE) + '</span> / 個';

      if (discountCount > 0 && inlineActual && inlineActVal) {
        var actualUnit = Math.floor(total / qty);
        inlineActVal.innerHTML = formatYen(actualUnit);
        inlineActual.style.display = '';
      } else if (inlineActual) {
        inlineActual.style.display = 'none';
      }
    }
  }

  /* ------------------------------------------------------------------
     STEP 4: カートボタン制御
  ------------------------------------------------------------------ */
  function renderCartState() {
    var btn  = document.getElementById('bathbombAddToCartBtn');
    var note = document.getElementById('bathbombCartNote');
    if (!btn) return;

    var remaining = getLimit() - getTotalScents();

    if (remaining === 0) {
      btn.disabled = false;
      if (note) note.textContent = '';
    } else {
      btn.disabled = true;
      if (note) note.textContent = '香りをあと' + remaining + '個選択してください';
    }
  }

  /* ------------------------------------------------------------------
     カートに追加
  ------------------------------------------------------------------ */
  function initAddToCart() {
    var btn       = document.getElementById('bathbombAddToCartBtn');
    var btnText   = btn && btn.querySelector('.bathbomb-btn-text');
    var btnLoading = btn && btn.querySelector('.bathbomb-btn-loading');
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      btn.disabled = true;
      if (btnText)    btnText.style.display    = 'none';
      if (btnLoading) btnLoading.style.display = '';

      if (state.purchaseType === 'subscription') {
        addSubscriptionToCart(btn, btnText, btnLoading);
      } else {
        addOnetimeToCart(btn, btnText, btnLoading);
      }
    });
  }

  function addSubscriptionToCart(btn, btnText, btnLoading) {
    // 最も多く選択された香りの定期購入専用バリアントIDを使用
    var topKey     = null;
    var maxCount   = 0;
    var properties = {};

    SCENT_KEYS.forEach(function (key) {
      var count = state.scentCounts[key] || 0;
      if (count === 0) return;
      properties[SCENT_CONFIG[key].label] = count + '個';
      if (count > maxCount) {
        maxCount = count;
        topKey   = key;
      }
    });

    var variantId = topKey ? SUB_VARIANT_MAP[topKey] : null;

    if (!variantId) {
      resetCartBtn(btn, btnText, btnLoading);
      alert('バリアントが見つかりません。');
      return;
    }

    fetchCartAdd({
      id: variantId,
      quantity: 1,
      selling_plan: MIKAWAYA_PLAN_ID,
      properties: properties
    }, btn, btnText, btnLoading);
  }

  function addOnetimeToCart(btn, btnText, btnLoading) {
    // 選択された香りのうち最初のvariant_idを使用し、全香り数をpropertiesに付与
    var variantId  = null;
    var properties = {};

    SCENT_KEYS.forEach(function (key) {
      var count = state.scentCounts[key] || 0;
      if (count === 0) return;
      var vKey = SCENT_CONFIG[key].variantKey;
      if (!variantId && window.BATHBOMB_VARIANTS) {
        variantId = window.BATHBOMB_VARIANTS[vKey];
      }
      properties[SCENT_CONFIG[key].label] = count + '個';
    });

    if (!variantId) {
      resetCartBtn(btn, btnText, btnLoading);
      alert('バリアントが見つかりません。');
      return;
    }

    fetchCartAdd(
      { id: variantId, quantity: state.qty, properties: properties },
      btn, btnText, btnLoading
    );
  }

  function fetchCartAdd(body, btn, btnText, btnLoading) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        alert('エラーが発生しました。もう一度お試しください。');
        resetCartBtn(btn, btnText, btnLoading);
      });
  }

  function resetCartBtn(btn, btnText, btnLoading) {
    btn.disabled = false;
    if (btnText)    btnText.style.display    = '';
    if (btnLoading) btnLoading.style.display = 'none';
  }

  /* ------------------------------------------------------------------
     初期化
  ------------------------------------------------------------------ */
  function init() {
    if (!window.bathbombPage) return;

    initPurchaseType();
    initQuantity();
    initScentGrid();
    initAddToCart();

    renderScentGrid();
    renderQtyPromo();
    renderQtyDiscountBanner();
    renderPrice();
    renderCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
